export default __webpack_public_path__ + "static/media/aryan.4411bbe4.png";